//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  gr: "กรีซ",
  gl: "กรีนแลนด์",
  gu: "กวม",
  gp: "กวาเดอลูป",
  kh: "กัมพูชา",
  gt: "กัวเตมาลา",
  qa: "กาตาร์",
  gh: "กานา",
  ga: "กาบอง",
  gy: "กายอานา",
  gn: "กินี",
  gw: "กินี-บิสเซา",
  gd: "เกรเนดา",
  kr: "เกาหลีใต้",
  kp: "เกาหลีเหนือ",
  cx: "เกาะคริสต์มาส",
  gs: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช",
  nf: "เกาะนอร์ฟอล์ก",
  bv: "เกาะบูเว",
  im: "เกาะแมน",
  hm: "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์",
  gg: "เกิร์นซีย์",
  gm: "แกมเบีย",
  ci: "โกตดิวัวร์",
  mo: "เขตปกครองพิเศษมาเก๊าแห่งสาธารณรัฐประชาชนจีน",
  hk: "เขตปกครองพิเศษฮ่องกงแห่งสาธารณรัฐประชาชนจีน",
  cd: "คองโก - กินชาซา",
  cg: "คองโก - บราซซาวิล",
  km: "คอโมโรส",
  cr: "คอสตาริกา",
  kz: "คาซัคสถาน",
  ki: "คิริบาส",
  cu: "คิวบา",
  kg: "คีร์กีซสถาน",
  cw: "คูราเซา",
  kw: "คูเวต",
  ke: "เคนยา",
  cv: "เคปเวิร์ด",
  ca: "แคนาดา",
  cm: "แคเมอรูน",
  hr: "โครเอเชีย",
  co: "โคลอมเบีย",
  ge: "จอร์เจีย",
  jo: "จอร์แดน",
  jm: "จาเมกา",
  dj: "จิบูตี",
  cn: "จีน",
  je: "เจอร์ซีย์",
  td: "ชาด",
  cl: "ชิลี",
  cz: "เช็ก",
  sm: "ซานมาริโน",
  ws: "ซามัว",
  sa: "ซาอุดีอาระเบีย",
  eh: "ซาฮาราตะวันตก",
  sx: "ซินต์มาร์เทน",
  zw: "ซิมบับเว",
  sy: "ซีเรีย",
  sd: "ซูดาน",
  ss: "ซูดานใต้",
  sr: "ซูรินาเม",
  sc: "เซเชลส์",
  kn: "เซนต์คิตส์และเนวิส",
  bl: "เซนต์บาร์เธเลมี",
  mf: "เซนต์มาร์ติน",
  lc: "เซนต์ลูเซีย",
  vc: "เซนต์วินเซนต์และเกรนาดีนส์",
  sh: "เซนต์เฮเลนา",
  sn: "เซเนกัล",
  rs: "เซอร์เบีย",
  st: "เซาตูเมและปรินซิปี",
  sl: "เซียร์ราลีโอน",
  pm: "แซงปีแยร์และมีเกอลง",
  zm: "แซมเบีย",
  so: "โซมาเลีย",
  cy: "ไซปรัส",
  jp: "ญี่ปุ่น",
  ps: "ดินแดนปาเลสไตน์",
  dk: "เดนมาร์ก",
  dm: "โดมินิกา",
  tt: "ตรินิแดดและโตเบโก",
  to: "ตองกา",
  tl: "ติมอร์-เลสเต",
  tr: "ตุรกี",
  tn: "ตูนิเซีย",
  tv: "ตูวาลู",
  tm: "เติร์กเมนิสถาน",
  tk: "โตเกเลา",
  tg: "โตโก",
  tw: "ไต้หวัน",
  tj: "ทาจิกิสถาน",
  tz: "แทนซาเนีย",
  th: "ไทย",
  va: "นครวาติกัน",
  no: "นอร์เวย์",
  na: "นามิเบีย",
  nr: "นาอูรู",
  ni: "นิการากัว",
  nc: "นิวแคลิโดเนีย",
  nz: "นิวซีแลนด์",
  nu: "นีอูเอ",
  nl: "เนเธอร์แลนด์",
  bq: "เนเธอร์แลนด์แคริบเบียน",
  np: "เนปาล",
  ng: "ไนจีเรีย",
  ne: "ไนเจอร์",
  br: "บราซิล",
  io: "บริติชอินเดียนโอเชียนเทร์ริทอรี",
  bn: "บรูไน",
  bw: "บอตสวานา",
  ba: "บอสเนียและเฮอร์เซโกวีนา",
  bd: "บังกลาเทศ",
  bg: "บัลแกเรีย",
  bb: "บาร์เบโดส",
  bh: "บาห์เรน",
  bs: "บาฮามาส",
  bi: "บุรุนดี",
  bf: "บูร์กินาฟาโซ",
  bj: "เบนิน",
  be: "เบลเยียม",
  by: "เบลารุส",
  bz: "เบลีซ",
  bm: "เบอร์มิวดา",
  bo: "โบลิเวีย",
  pk: "ปากีสถาน",
  pa: "ปานามา",
  pg: "ปาปัวนิวกินี",
  py: "ปารากวัย",
  pw: "ปาเลา",
  pe: "เปรู",
  pr: "เปอร์โตริโก",
  pt: "โปรตุเกส",
  pl: "โปแลนด์",
  fr: "ฝรั่งเศส",
  fj: "ฟิจิ",
  fi: "ฟินแลนด์",
  ph: "ฟิลิปปินส์",
  gf: "เฟรนช์เกียนา",
  tf: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์",
  pf: "เฟรนช์โปลินีเซีย",
  bt: "ภูฏาน",
  mn: "มองโกเลีย",
  ms: "มอนต์เซอร์รัต",
  me: "มอนเตเนโกร",
  mu: "มอริเชียส",
  mr: "มอริเตเนีย",
  md: "มอลโดวา",
  mt: "มอลตา",
  mv: "มัลดีฟส์",
  mk: "มาซิโดเนียเหนือ",
  mg: "มาดากัสการ์",
  yt: "มายอต",
  mq: "มาร์ตินีก",
  mw: "มาลาวี",
  ml: "มาลี",
  my: "มาเลเซีย",
  mx: "เม็กซิโก",
  mm: "เมียนมาร์ (พม่า)",
  mz: "โมซัมบิก",
  mc: "โมนาโก",
  ma: "โมร็อกโก",
  fm: "ไมโครนีเซีย",
  gi: "ยิบรอลตาร์",
  ug: "ยูกันดา",
  ua: "ยูเครน",
  ye: "เยเมน",
  de: "เยอรมนี",
  rw: "รวันดา",
  ru: "รัสเซีย",
  re: "เรอูนียง",
  ro: "โรมาเนีย",
  lu: "ลักเซมเบิร์ก",
  lv: "ลัตเวีย",
  la: "ลาว",
  li: "ลิกเตนสไตน์",
  lt: "ลิทัวเนีย",
  ly: "ลิเบีย",
  ls: "เลโซโท",
  lb: "เลบานอน",
  lr: "ไลบีเรีย",
  vu: "วานูอาตู",
  wf: "วาลลิสและฟุตูนา",
  ve: "เวเนซุเอลา",
  vn: "เวียดนาม",
  lk: "ศรีลังกา",
  es: "สเปน",
  sj: "สฟาลบาร์และยานไมเอน",
  sk: "สโลวะเกีย",
  si: "สโลวีเนีย",
  ch: "สวิตเซอร์แลนด์",
  se: "สวีเดน",
  us: "สหรัฐอเมริกา",
  ae: "สหรัฐอาหรับเอมิเรตส์",
  gb: "สหราชอาณาจักร",
  do: "สาธารณรัฐโดมินิกัน",
  cf: "สาธารณรัฐแอฟริกากลาง",
  sg: "สิงคโปร์",
  ck: "หมู่เกาะคุก",
  ky: "หมู่เกาะเคย์แมน",
  cc: "หมู่เกาะโคโคส (คีลิง)",
  sb: "หมู่เกาะโซโลมอน",
  tc: "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
  mp: "หมู่เกาะนอร์เทิร์นมาเรียนา",
  vg: "หมู่เกาะบริติชเวอร์จิน",
  pn: "หมู่เกาะพิตแคร์น",
  fk: "หมู่เกาะฟอล์กแลนด์",
  fo: "หมู่เกาะแฟโร",
  mh: "หมู่เกาะมาร์แชลล์",
  um: "หมู่เกาะรอบนอกของสหรัฐอเมริกา",
  vi: "หมู่เกาะเวอร์จินของสหรัฐอเมริกา",
  ax: "หมู่เกาะโอลันด์",
  as: "อเมริกันซามัว",
  au: "ออสเตรเลีย",
  at: "ออสเตรีย",
  ad: "อันดอร์รา",
  af: "อัฟกานิสถาน",
  az: "อาเซอร์ไบจาน",
  ar: "อาร์เจนตินา",
  am: "อาร์เมเนีย",
  aw: "อารูบา",
  gq: "อิเควทอเรียลกินี",
  it: "อิตาลี",
  in: "อินเดีย",
  id: "อินโดนีเซีย",
  iq: "อิรัก",
  il: "อิสราเอล",
  ir: "อิหร่าน",
  eg: "อียิปต์",
  uz: "อุซเบกิสถาน",
  uy: "อุรุกวัย",
  ec: "เอกวาดอร์",
  et: "เอธิโอเปีย",
  er: "เอริเทรีย",
  sv: "เอลซัลวาดอร์",
  ee: "เอสโตเนีย",
  sz: "เอสวาตีนี",
  ai: "แองกวิลลา",
  ao: "แองโกลา",
  aq: "แอนตาร์กติกา",
  ag: "แอนติกาและบาร์บูดา",
  za: "แอฟริกาใต้",
  dz: "แอลจีเรีย",
  al: "แอลเบเนีย",
  om: "โอมาน",
  is: "ไอซ์แลนด์",
  ie: "ไอร์แลนด์",
  hn: "ฮอนดูรัส",
  hu: "ฮังการี",
  ht: "เฮติ",
};
